<template>
  <div class="gx-pb custom-el-wrapper">
    <div class="gx-pb__head">
      <!--      <h1 class="gx-main__title" style="margin-bottom: 0;">商品看板</h1>-->
      <button type="button" class="gx-pb__btn" @click="openGroupMgmt">分组管理</button>
      <button type="button" class="gx-pb__btn gx-pb__btn--red" @click="openPublishDialog" v-if="false">+ 发布任务</button>
    </div>

    <!--平台-->
    <div class="gx-pb__plat-tabs">
      <button
          v-for="p in platformOptions"
          :key="p.value"
          type="button"
          class="gx-pb__plat-tab"
          :class="{ 'gx-pb__plat-tab--on': searchData.platform === p.value }"
          @click.stop="switchPlatform(p.value)"
      >{{ p.label }}</button>
    </div>

    <!-- 状态筛选栏 -->
    <div class="gx-pb__status-tabs" v-if="false">
      <button
          v-for="p in statusOptions"
          :key="p.value"
          type="button"
          class="gx-pb__status-tab"
          :class="{ 'gx-pb__status-tab--on': searchData.status === p.value }"
          @click.stop="switchStatus(p.value)"
      >
        <span class="gx-pb__status-tab-dot" :style="{background:p.color}" v-if="p.value"></span>
        <span>{{ p.label }}({{p.count}})</span>
      </button>
    </div>
    <!-- 筛选栏 -->
    <div class="gx-pb__filter custom-form-wrap">
      <el-form inline size="mini">
        <el-form-item >
          <el-select v-model="searchData.shop_id" placeholder="全部店铺" clearable style="width:160px" filterable>
            <el-option value="" label="全部店铺"></el-option>
            <el-option v-for="item in shopOptions" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="searchData.group_id" placeholder="全部分组" clearable class="w140" filterable>
            <el-option value="" label="全部分组"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="searchData.product_id" placeholder="商品ID" clearable class="w140"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="searchData.product_name" placeholder="商品名称" clearable class="w140"></el-input>
        </el-form-item>
        <template v-if="searchData.platform!==7">
          <el-form-item label="">
            <el-select v-model="searchData.sales_type" placeholder="全部售卖类型" class="w140">
              <el-option v-for="item in salesTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="searchData.carrier_type" placeholder="全部载体类型" class="w140">
              <el-option v-for="item in carrierTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </template>

      </el-form>
      <div class="gx-pd__range">
        <div class="gx-pd__range-item" v-for="item in searchData.platform!==7?ddRangeFilter:wxRangeFilter" :key="item.key">
          <span class="gx-pd__range-item-label">{{ item.label }}</span>
          <el-input v-model="rangeCustom[item.key+'_min']" placeholder="最小" type="number" size="mini" class="w50"></el-input>
          <span style="font-size: 11px;color: #999999">~</span>
          <el-input v-model="rangeCustom[item.key+'_max']" placeholder="最大" type="number" size="mini" class="w50"></el-input>
        </div>
      </div>
      <el-form inline size="mini" style="align-items: center">
        <el-form-item label="" style="margin-right: auto">
          <div class="gx-pb__time">
            <button
                v-for="t in timeOptions"
                :key="t.id"
                type="button"
                class="gx-pb__time-btn"
                :class="{ 'gx-pb__time-btn--on': timeSelectId === t.id }"
                @click="selectTime(t)"
            >{{ t.name }}</button>
            <el-date-picker
                v-model="customDateRange"
                type="daterange"
                range-separator="-"
                size="mini"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="datePickerOptions"
                @change="customDateChange"
                style="width:230px;">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="display: flex;align-items: center;gap: 7px">
           <el-button type="primary" @click="loadData(1)">查询</el-button>
            <el-button  @click="resetSearch" style="margin-left: 0;">重置</el-button>
            <button type="button" class="gx-pd__btn-config" @click="openFieldConfig" >指标配置</button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作栏-->
    <div class="gx-pb__opts"  v-if="selectedRows.length ">
      <div class="gx-pd__sel-tag">
        <span class="gx-pd__sel-tag-dot"></span>
        <span>已选 {{selectedRows.length}} 个商品</span>
      </div>
      <button type="button" class="gx-pb__btn gx-pb__btn-sm" @click="openBatchGroupDialog()">批量设置分组</button>
      <button type="button" class="gx-pb__btn gx-pb__btn-sm gx-pb__btn--cancel"  @click="selectedRows=[]">取消选择</button>
    </div>

    <!-- 数据洞察 -->
    <section class="gx-pb__insight" v-if="false">
      <header class="gx-pb__insight-head" @click="insightShow =!insightShow">
        <div class="gx-pb__insight-title">数据洞察</div>
        <div class="gx-pb__insight-dec">近期增幅过大商品 · 高退款率 · 低转化率 · 分组分布</div>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" :style="`transform: rotate(${insightShow?'180':'0'}deg); transition: transform 0.2s;`">
          <path d="M2 4.5l4 4 4-4" stroke="#999" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </header>

      <div class="gx-pb__insight-grid" v-if="insightShow">
        <!-- 近期增幅过大商品 -->
        <article class="gx-pb__insight-card gx-pb__insight-card--rise">
          <div class="gx-pb__insight-card-head">
            <span class="gx-pb__insight-icon gx-pb__insight-icon--rise">🚀</span>
            <h4 class="gx-pb__insight-card-title text-red">近期增幅过大商品</h4>
          </div>
          <ul class="gx-pb__insight-list">
            <li v-for="(item, idx) in insight.riseList" :key="item.product_id" class="gx-pb__insight-row">
              <span class="gx-pb__insight-rank">#{{ idx + 1 }}</span>
              <span style="font-size: 13px">👔</span>
              <span class="gx-pb__insight-name" :title="item.title">{{ item.title }}</span>
              <span class="gx-pb__insight-val text-green">+{{ item.delta }}%</span>
            </li>
            <li v-if="!insight.riseList.length" class="gx-pb__insight-empty">暂无增幅异常商品</li>
          </ul>
        </article>

        <!-- 高退款率商品 -->
        <article class="gx-pb__insight-card gx-pb__insight-card--refund">
          <div class="gx-pb__insight-card-head">
            <span class="gx-pb__insight-icon gx-pb__insight-icon--refund">⚠️</span>
            <h4 class="gx-pb__insight-card-title text-orange">高退款率商品</h4>
            <span class="gx-pb__insight-badge text-orange">{{ insight.refundList.length }}个</span>
          </div>
          <ul class="gx-pb__insight-list">
            <li v-for="(item, idx) in insight.refundList" :key="item.product_id" class="gx-pb__insight-row">
              <span style="font-size: 13px">👔</span>
              <span class="gx-pb__insight-name" :title="item.title">{{ item.title }}</span>
              <span class="gx-pb__insight-val text-orange">{{ item.refund_rate }}%</span>
            </li>
            <li v-if="!insight.refundList.length" class="gx-pb__insight-empty">暂无高退款率商品</li>
          </ul>
        </article>

        <!-- 低转化率商品 -->
        <article class="gx-pb__insight-card gx-pb__insight-card--conv">
          <div class="gx-pb__insight-card-head">
            <span class="gx-pb__insight-icon gx-pb__insight-icon--conv">📉</span>
            <h4 class="gx-pb__insight-card-title text-purple">低转化率商品</h4>
            <span class="gx-pb__insight-badge text-purple">{{ insight.lowConvList.length }}个</span>
          </div>
          <ul class="gx-pb__insight-list">
            <li v-if="!insight.lowConvList.length" class="gx-pb__insight-empty">暂无低转化率商品 🎉</li>
            <li v-for="(item, idx) in insight.lowConvList" :key="item.product_id" class="gx-pb__insight-row">
              <span class="gx-pb__insight-rank" :class="'gx-pb__insight-rank--' + (idx + 1)">{{ idx + 1 }}</span>
              <span class="gx-pb__insight-name" :title="item.title">{{ item.title }}</span>
              <span class="gx-pb__insight-val text-purple">{{ item.conversion_rate }}%</span>
            </li>
          </ul>
        </article>

        <!-- 分组分布 -->
        <article class="gx-pb__insight-card gx-pb__insight-card--group">
          <div class="gx-pb__insight-card-head">
            <span class="gx-pb__insight-icon">📊</span>
            <h4 class="gx-pb__insight-card-title">分组分布 · {{ insight.group.platformName }}</h4>
          </div>
          <ul class="gx-pb__insight-bars">
            <li v-for="g in insight.group.items" :key="g.key" class="gx-pb__insight-bar-row">
              <div class="gx-pb__insight-bar-top">
                <span class="gx-pb__insight-bar-label" :style="{ color: g.color }">{{ g.label }}</span>
                <span class="gx-pb__insight-bar-count">{{ g.count }}件</span>
              </div>
              <div class="gx-pb__insight-bar-track">
                <span class="gx-pb__insight-bar-fill" :style="{ width: g.pct + '%', background: g.color }"></span>
              </div>
            </li>
          </ul>
          <div class="gx-pb__insight-foot">总计 {{ insight.group.total }} 件商品</div>
        </article>
      </div>
    </section>

    <!-- 数据表格+分页 -->
    <div class="table-page-wrapper">
      <div class="gx-pb__table">
        <table>
          <thead>
            <tr>
              <th class="" style="width: 36px">
                <span class="gx-pb__check" :class="{ 'gx-pb__check--on': allChecked }" @click="toggleAll">
                  <svg v-if="allChecked" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </th>
              <th class=" ">店铺</th>
              <th class=""> ID </th>
              <th  class=" ">标题 </th>
              <th  v-for="col in activeFields" :key="col.key" class="" >
                <span :title="col.tip ? col.label : undefined">{{ col.short }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tableData" :key="row.product_id">
              <td class="">
                <span class="gx-pb__check" :class="{ 'gx-pb__check--on': selectedRows.includes(row.product_id) }" @click="toggleOne(row.product_id)">
                  <svg v-if="selectedRows.includes(row.product_id)" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
                </span>
              </td>
              <td class="">
                <div class="gx-pb__shop-cell">
                  <span class="gx-pb__shop-icon" v-if="row.shop_name">{{row.shop_name[0]}}</span>
                  <span class="gx-pb__shop-name">{{ row.shop_name }}</span>
  <!--                <span class="gx-pb__plat-tag" :class="row.platform == 7 ? 'gx-pb__plat-tag&#45;&#45;wx' : 'gx-pb__plat-tag&#45;&#45;dy'">{{ platformName(row.platform) }}</span>-->
                </div>
              </td>
              <td class="">
                <div class="gx-pb__id">{{ row.product_id }}</div>
  <!--              <div class="gx-pb__id-cell">
                  <span v-if="row.group_name" class="gx-pb__group-tag">{{ row.group_name }}</span>
                  <span v-else class="gx-pb__group-tag gx-pb__group-tag&#45;&#45;empty">未分组</span>
                </div>-->
              </td>
              <td>
                <div class="gx-pb__td-title">{{ row.title }}</div>
              </td>
              <td v-for="col in activeFields" :key="col.key">
                <span :class="cellClass(col, row[col.key])">{{ formatCell(col, row[col.key]) }}</span>
              </td>
            </tr>
            <tr v-if="!tableData.length">
              <td :colspan="5 + activeFields.length" class="gx-pb__empty">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="gx-pb__page">
        <Pagination :total="pageData.total" :page.sync="pageData.page" :limit.sync="pageData.limit" :page-sizes="[20, 50, 100]" @pagination="loadData(pageData.page)"  layout="total, sizes, prev, pager, next, jumper" />
      </div>
    </div>

    <!-- 指标配置弹窗 -->
    <div v-if="showFieldConfig" class="gx-modal gx-pb__field-config-modal" @click.self="closeFieldConfig">
      <div class="gx-modal-box gx-pb__field-config-box">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">指标配置</span>
          <button class="gx-modal-close" @click="closeFieldConfig">✕</button>
        </div>
        <div class="gx-modal-body">
          <div v-for="group in configFields" :key="group.name" class="gx-pb__cfg-group">
            <div class="gx-pb__cfg-group-title">
              <span class="gx-pb__cfg-bar" :style="{ background: groupBar(group.type) }"></span>
              {{ group.name }}
              <span class="gx-pb__cfg-count">{{ groupCheckedCount(group) }} / {{ group.fields.length }}</span>
              <button class="gx-pb__cfg-checkall" @click="toggleGroup(group)">{{ groupAllChecked(group) ? '取消全选' : '全选' }}</button>
            </div>
            <div class="gx-pb__cfg-items">
              <label
                v-for="f in group.fields"
                :key="f.key"
                class="gx-pb__cfg-item"
                :class="{ 'gx-pb__cfg-item--on': tempSelectedFields.includes(f.key), 'gx-pb__cfg-item--locked': f.locked }"
              >
                <input type="checkbox" :value="f.key" v-model="tempSelectedFields" :disabled="f.locked" />
                <span>{{ f.label }}</span>
<!--                <span v-if="f.locked" class="gx-pb__cfg-locked">锁定</span>-->
              </label>
            </div>
          </div>
        </div>
        <div class="gx-modal-foot gx-modal-foot--gray">
          <button class="gx-modal-foot-btn" @click="closeFieldConfig">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" @click="confirmFieldConfig">确认</button>
        </div>
      </div>
    </div>

    <!-- 商品分组管理弹窗 -->
    <div v-if="groupMgmtVisible" class="gx-modal" @click.self="groupMgmtVisible = false">
      <div class="gx-modal-box gx-pb__modal-box--lg">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">商品分组管理</span>
          <button class="gx-modal-close" @click="groupMgmtVisible = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-pb__gm-toolbar">
            <button class="gx-pb__btn" @click="openGroupForm(null)">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none"><path d="M5.5 1v9M1 5.5h9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" /></svg>
              新增分组
            </button>
          </div>
          <div class="gx-pb__gm-table">
            <table>
              <thead>
              <tr>
                <th v-for="h in ['分组名称', '商品数', '排序', '操作']" :key="h">{{ h }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,index) in groupList" :key="item.id">
                <td>{{ item.name }}</td>
                <td class="gx-pb__mono">
                  <div class="gx-pb__red">{{ item.product_count ?? '-' }}</div>
                </td>
                <td>
                  <div class="gx-pb__gm-sort">
                    <button @click="moveProductGroup(item, index,'asc')">↑</button>
                    <button @click="moveProductGroup(item, index,'desc')">↓</button>
                  </div>
                </td>
                <td>
                  <div class="gx-pb__gm-ops">
                    <button class="gx-pb__gm-op gx-pb__gm-op--edit" @click="openGroupForm(g)">编辑</button>
                    <button class="gx-pb__gm-op gx-pb__gm-op--del" @click="delGroup(g)">删除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="groupList.length === 0">
                <td colspan="4" class="gx-pb__empty">暂无分组</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="gx-modal-foot no-top-bor">
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" @click="groupMgmtVisible = false">完成</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑分组弹窗 -->
    <div v-if="groupFormVisible" class="gx-modal" @click.self="groupFormVisible = false">
      <div class="gx-modal-box">
        <div class="gx-modal-head gx-modal-head--gray">
          <span class="gx-modal-title">{{ groupForm.id ? '编辑分组' : '新增分组' }}</span>
          <button class="gx-modal-close" @click="groupFormVisible = false">✕</button>
        </div>
        <div class="gx-modal-body">
          <div class="gx-pb__modal-label">分组名称</div>
          <el-input v-model="groupForm.name" size="small" maxlength="50" show-word-limit placeholder="请输入分组名称" ></el-input>
          <div class="gx-pb__modal-label" style="margin-top: 14px">排序值</div>
          <div class="gx-pb__gm-sort-input">
            <button @click="groupForm.sort = Math.max(0, groupForm.sort - 1)">−</button>
            <input v-model.number="groupForm.sort" type="number" min="0" />
            <button @click="groupForm.sort += 1">+</button>
          </div>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="groupFormVisible = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="groupFormLoading" @click="submitGroupForm">
            {{ groupFormLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 批量设置分组弹窗 -->
    <div v-if="batchGroupVisible" class="gx-modal" @click.self="batchGroupVisible = false">
      <div class="gx-modal-box gx-pb__modal-box--sm">
        <div class="gx-modal-head gx-modal-head--gray ">
          <span class="gx-modal-title">设置商品分组</span>
          <button class="gx-modal-close" @click="batchGroupVisible = false">✕</button>
        </div>
        <div class="gx-modal-body custom-form-wrap">
          <el-form size="small">
            <div class="gx-pd__sel-tag">
              <span class="gx-pd__sel-tag-dot"></span>
              <span>已选 {{selectedRows.length}} 个商品</span>
            </div>
            <el-form-item label="选择分组">
              <el-select v-model="batchGroupId" placeholder="请选择分组" clearable style="width: 90%">
                  <el-option label="移出分组" :value="0"></el-option>
                  <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="gx-modal-foot">
          <button class="gx-modal-foot-btn" @click="batchGroupVisible = false">取消</button>
          <button class="gx-modal-foot-btn gx-modal-foot-btn--yellow" :disabled="batchGroupLoading" @click="submitBatchSetGroup">
            {{ batchGroupLoading ? '保存中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 发布任务弹窗 -->
    <div v-if="publishVisible" class="gx-modal" @click.self="closePublishDialog">
      <div class="gx-modal-box gx-pb__pub-box">
        <div class="gx-pb__pub-head">
          <span class="gx-pb__pub-head-title">+ 发布任务</span>
          <div class="gx-pb__pub-head-ops">
            <button type="button" class="gx-pb__pub-reset" @click="resetPublishFilter">{{searchData.platform===1?'抖店':'微店'}}</button>
            <button type="button" class="gx-pb__pub-close" @click="closePublishDialog">✕</button>
          </div>
        </div>
        <div class="gx-pb__pub-tabs">
          <div class="gx-pb__pub-tab" :class="{ 'gx-pb__pub-tab--on': publishMode === 'auto' }" @click="switchPublishMode('auto')">
            <div class="gx-pb__pub-tab-title"><span class="gx-pb__pub-tab-icon">🤖</span>自动发布</div>
            <div class="gx-pb__pub-tab-sub">系统按筛选条件自动发布</div>
          </div>
          <div class="gx-pb__pub-tab" :class="{ 'gx-pb__pub-tab--on': publishMode === 'custom' }" @click="switchPublishMode('custom')">
            <div class="gx-pb__pub-tab-title"><span class="gx-pb__pub-tab-icon">✏️</span>自定义发布</div>
            <div class="gx-pb__pub-tab-sub">手动选商品+模板+自定义</div>
          </div>
        </div>
        <!--自动发布-步骤条-->
        <div class="gx-pb__pub-steps" v-if="publishMode === 'auto'">
          <div class="gx-pb__pub-step" :class="{ 'gx-pb__pub-step--on': publishStep >= 1 }">
            <span class="gx-pb__pub-step-no">{{ publishStep > 1 ? '✓' : '1' }}</span>
            <span class="gx-pb__pub-step-label">筛选条件</span>
            <span class="gx-pb__pub-step-line" :class="{ 'gx-pb__pub-step-line--on': publishStep > 1 }"></span>
          </div>

          <div class="gx-pb__pub-step" :class="{ 'gx-pb__pub-step--on': publishStep >= 2 }">
            <span class="gx-pb__pub-step-no">2</span>
            <span class="gx-pb__pub-step-label">配置商品</span>
          </div>
        </div>
        <div class="gx-pb__pub-body">
          <template v-if="publishMode === 'auto' && publishStep === 1">
            <div class="gx-pb__pub-label"><span class="gx-pb__pub-label-no">1</span>商品数据时间范围</div>
            <div class="gx-pb__pub-pills">
              <button
                v-for="d in publishDayOptions"
                :key="d.value"
                type="button"
                class="gx-pb__pub-pill"
                :class="{ 'gx-pb__pub-pill--red': publishFilter.days === d.value }"
                @click="publishFilter.days = d.value"
              >{{ d.label }}</button>
            </div>
            <div class="gx-pb__pub-label"><span class="gx-pb__pub-label-no">2</span>商品范围</div>
            <div class="gx-pb__pub-pills">
              <button
                v-for="s in publishSoldOptions"
                :key="s.value"
                type="button"
                class="gx-pb__pub-pill"
                :class="{ 'gx-pb__pub-pill--yellow': publishFilter.sold === s.value }"
                @click="publishFilter.sold = s.value"
              >{{ s.label }}</button>
            </div>
            <div class="gx-pb__pub-label"><span class="gx-pb__pub-label-no">3</span>分组筛选</div>
            <div class="gx-pb__pub-groups">
              <div class="gx-pb__pub-group">
                <div class="gx-pb__pub-group-label">店铺分组</div>
                <el-select v-model="publishFilter.shopGroupId" placeholder="全部分组" size="small" clearable>
                  <el-option value="" label="全部分组"></el-option>
                  <el-option v-for="item in shopGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
              <div class="gx-pb__pub-group">
                <div class="gx-pb__pub-group-label">商品分组</div>
                <el-select v-model="publishFilter.productGroupId" placeholder="全部分组" size="small" clearable>
                  <el-option value="" label="全部分组"></el-option>
                  <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="gx-pb__pub-next-wrap">
              <button type="button" class="gx-pb__pub-next" @click="publishGoNext">下一步 →</button>
            </div>
          </template>
          <template v-else-if="publishMode === 'auto' && publishStep === 2">
            <div class="gx-pb__pub-cond">
              <span class="gx-pb__pub-cond-label">筛选条件：</span>
              <span class="gx-pb__pub-cond-pill">{{ publishDaysText }}</span>
              <span class="gx-pb__pub-cond-pill">{{ publishSoldText }}</span>
              <button type="button" class="gx-pb__pub-cond-edit" @click="publishStep = 1">+ 修改</button>
            </div>
            <div class="gx-pb__pub-match-tip">系统自动匹配到 <b>{{ publishProducts.length }}</b> 个商品，已分配任务类型，请确认后配置进入方式：</div>
            <div class="gx-pb__pub-banner">⚠️ 系统已自动匹配任务类型，可在下方按商品调整进入方式</div>
            <div class="gx-pb__pub-cards">
              <div v-for="p in publishProducts" :key="p.product_id" class="gx-pb__pub-card">
                <div class="gx-pb__pub-card-head">
                  <span class="gx-pb__pub-card-ico">👔</span>
                  <div class="gx-pb__pub-card-info">
                    <div class="gx-pb__pub-card-title">{{ p.title }}</div>
                    <div class="gx-pb__pub-card-id">ID:{{ p.product_id }}</div>
                  </div>
                  <span class="gx-pb__pub-tasktag" :style="pubType(p.taskType).style" >{{ pubType(p.taskType).label }}</span>
                </div>
                <div class="gx-pb__pub-card-box">
                  <div class="gx-pb__pub-card-row">
                    <span class="gx-pb__pub-taskpill" :style="pubType(p.taskType).style">{{ pubType(p.taskType).label }}</span>
                    <span class="gx-pb__pub-taskid">ID:{{ p.taskId || '--' }}</span>
                    <span class="gx-pb__pub-row-space"></span>
                    <button type="button" class="gx-pb__pub-scan" :class="{ 'gx-pb__pub-scan--on': p.enter === 'scan' }" @click="p.enter = 'scan'">🖥 扫码</button>
                    <button type="button" class="gx-pb__pub-search" :class="{ 'gx-pb__pub-search--on': p.enter === 'search' }" @click="p.enter = 'search'">🔍 搜索</button>
                  </div>
                  <template v-if="p.enter === 'search'">
                    <div v-for="(kw, ki) in p.keywords" :key="ki" class="gx-pb__pub-kw-row">
                      <el-input v-model="kw.value" size="mini" maxlength="30" placeholder="请输入关键词"></el-input>
                      <button type="button" class="gx-pb__pub-kw-del" @click="removePublishKeyword(p, ki)">✕</button>
                    </div>
                    <button type="button" class="gx-pb__pub-kw-add" @click="addPublishKeyword(p)">+ 添加关键词</button>
                  </template>
                </div>
              </div>
            </div>
            <div class="gx-pb__pub-label">开始时间</div>
            <div class="gx-pb__pub-pills">
              <button type="button" class="gx-pb__pub-pill" :class="{ 'gx-pb__pub-pill--red': publishStart === 'now' }" @click="publishStart = 'now'">立即开始</button>
              <button type="button" class="gx-pb__pub-pill" :class="{ 'gx-pb__pub-pill--red': publishStart === 'date' }" @click="publishStart = 'date'">指定日期</button>
              <el-date-picker
                v-if="publishStart === 'date'"
                v-model="publishDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :picker-options="datePickerOptions"
                placeholder="选择开始日期"
                style="width:150px"
              ></el-date-picker>
            </div>
          </template>
          <div class="gx-pb__pub-cust" v-else>
            <div class="gx-pb__pub-cust-step">
              <div class="gx-pb__pub-cust-title text-gold">📌 第一步：选择要发布任务的商品</div>
              <div class="gx-pb__pub-cust-hint">手动输入商品ID（多个以英文逗号分隔）</div>
              <el-input
                v-model="customProductIds"
                type="textarea"
                size="mini"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="例: 38201974117366716724, WC20260001"
                style="background: transparent"
              ></el-input>
              <div class="gx-pb__pub-cust-warn">⚠️ 请先在商品列表勾选，或在此输入ID</div>
            </div>
            <div>
              <div class="gx-pb__pub-cust-title">第二步：选择任务配置方式</div>
              <div class="gx-pb__pub-sub-tabs">
                <button type="button" class="gx-pb__pub-sub-tab" :class="{ 'gx-pb__pub-sub-tab--on': customSubMode === 'template' }" @click="customSubMode = 'template'">
                  <span class="gx-pb__pub-sub-tab-ico">📋</span>选择模板
                </button>
                <button type="button" class="gx-pb__pub-sub-tab" :class="{ 'gx-pb__pub-sub-tab--on': customSubMode === 'custom' }" @click="customSubMode = 'custom'">
                  <span class="gx-pb__pub-sub-tab-ico">✏️</span>全自定义
                </button>
              </div>
              <template v-if="customSubMode === 'template'">
                <div class="gx-pb__pub-tpl-list">
                  <div
                    v-for="(tpl, ti) in customTemplates"
                    :key="ti"
                    class="gx-pb__pub-tpl-item"
                    :class="{ 'gx-pb__pub-tpl-item--on': customTemplateIdx === ti }"
                    @click="customTemplateIdx = ti"
                  >
                    <div class="gx-pb__pub-tpl-radio">
                      <span v-if="customTemplateIdx === ti" class="gx-pb__pub-tpl-radio-dot"></span>
                    </div>
                    <div class="gx-pb__pub-tpl-main">
                      <div class="gx-pb__pub-tpl-name">{{ tpl.name }}</div>
                      <div v-if="customTemplateIdx === ti" class="gx-pb__pub-tpl-detail">
                        <span>每天上限：{{ tpl.daily }}人</span>
                        <span>总上限：{{ tpl.total }}人</span>
                        <span>时间段：{{ tpl.period }}</span>
                        <span>步骤数：{{ tpl.steps }}步</span>
                      </div>
                    </div>
                    <span class="gx-pb__pub-tpl-tag" :style="pubType(tpl.type).style">{{ tpl.typeLabel }}</span>
                    <span class="gx-pb__pub-tpl-days">{{ tpl.days }}天</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="gx-pb__pub-cust-label">任务类型（可多选）</div>
                <div class="gx-pb__pub-sub-pills">
                  <button
                    v-for="opt in customFullTaskOptions"
                    :key="opt.key"
                    type="button"
                    class="gx-pb__pub-sub-pill"
                    :class="{ 'gx-pb__pub-sub-pill--on': customFullSelected.includes(opt.key) }"
                    :style="customFullSelected.includes(opt.key) ? { background: opt.color, borderColor: opt.color, color: '#fff' } : {}"
                    @click="toggleCustomFullTask(opt.key)"
                  ><span v-if="customFullSelected.includes(opt.key)">✓ </span> {{ opt.label }}</button>
                </div>
                <div class="gx-pb__pub-cust-nums">
                  <div class="gx-pb__pub-cust-num">
                    <label>天数</label>
                    <div class="gx-pb__pub-num-wrap">
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullDays = stepNum(customFullDays, -1)">−</button>
                      <input type="number" class="gx-pb__pub-num-input" v-model.number="customFullDays" min="1" />
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullDays = stepNum(customFullDays, 1)">+</button>
                    </div>
                  </div>
                  <div class="gx-pb__pub-cust-num">
                    <label>每天上限</label>
                    <div class="gx-pb__pub-num-wrap">
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullDaily = stepNum(customFullDaily, -1)">−</button>
                      <input type="number" class="gx-pb__pub-num-input" v-model.number="customFullDaily" min="1" />
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullDaily = stepNum(customFullDaily, 1)">+</button>
                    </div>
                  </div>
                  <div class="gx-pb__pub-cust-num">
                    <label>总上限</label>
                    <div class="gx-pb__pub-num-wrap">
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullTotal = stepNum(customFullTotal, -1)">−</button>
                      <input type="number" class="gx-pb__pub-num-input" v-model.number="customFullTotal" min="1" />
                      <button type="button" class="gx-pb__pub-num-btn" @click="customFullTotal = stepNum(customFullTotal, 1)">+</button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div>
              <div class="gx-pb__pub-cust-title">第三步：开始时间</div>
              <div class="gx-pb__pub-pills">
                <button type="button" class="gx-pb__pub-pill" :class="{ 'gx-pb__pub-pill--red': publishStart === 'now' }" @click="publishStart = 'now'">立即开始</button>
                <button type="button" class="gx-pb__pub-pill" :class="{ 'gx-pb__pub-pill--red': publishStart === 'date' }" @click="publishStart = 'date'">指定日期</button>
                <el-date-picker
                  v-if="publishStart === 'date'"
                  v-model="publishDate"
                  type="date"
                  size="mini"
                  value-format="yyyy-MM-dd"
                  :picker-options="datePickerOptions"
                  placeholder="选择开始日期"
                  style="width:150px"
                ></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="gx-modal-foot gx-modal-foot--bg">
          <button class="gx-modal-foot-btn" @click="closePublishDialog">取消</button>
          <button class="gx-modal-foot-btn gx-pb__pub-submit" :disabled="!pubCanSubmit" @click="submitPublishTask">发布任务</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Pagination from "@/components/newUi/Pagination.vue";

const douyinConfigFields = [
  {
    name: '核心指标',
    type: 'core',
    fields: [
      { key: 'exposure', label: '曝光', short: '曝光', fmt: 'bignum', width: 80, locked: true },
      { key: 'clicks', label: '点击量', short: '点击量', fmt: 'num', width: 75, locked: true },
      { key: 'click_rate', label: '点击率', short: '点击率', fmt: 'rate', width: 68 },
      { key: 'add_cart', label: '加购量', short: '加购量', fmt: 'num', width: 75 },
      { key: 'add_cart_rate', label: '加购率', short: '加购率', fmt: 'rate', width: 68 },
      { key: 'real_orders', label: '真实订单', short: '真实订单', fmt: 'num', width: 78 },
      { key: 'abnormal_orders', label: '异常订单', short: '异常订单', fmt: 'num', width: 78 },
      { key: 'conversion_rate', label: '转化率', short: '转化率', fmt: 'rate', width: 68 },
      { key: 'return_rate', label: '退货率', short: '退货率', fmt: 'rate', width: 68 }
    ]
  },
  {
    name: '交易指标',
    type: 'trade',
    fields: [
      { key: 'pay_amount', label: '用户支付金额', short: '支付金额', fmt: 'money', width: 100 },
      { key: 'order_count', label: '成交订单数', short: '订单数', fmt: 'num', width: 80 },
      { key: 'buyer_count', label: '成交人数', short: '成交人数', fmt: 'num', width: 85 },
      { key: 'avg_price', label: '客单价', short: '客单价', fmt: 'money', width: 80 },
      { key: 'refund_amount', label: '退款金额', short: '退款金额', fmt: 'money', width: 95 },
      { key: 'refund_count', label: '退款订单数', short: '退款单数', fmt: 'num', width: 85 },
      { key: 'stock', label: '实时可售库存', short: '可售库存', fmt: 'num', width: 85 }
    ]
  },
  {
    name: '流量指标',
    type: 'traffic',
    fields: [
      { key: 'exposure_uv', label: '商品曝光人数', short: '曝光人数', fmt: 'bignum', width: 90 },
      { key: 'click_uv', label: '商品点击人数', short: '点击人数', fmt: 'bignum', width: 90 },
      { key: 'exposure_click_rate', label: '曝光-点击率(人数)', short: '曝光点击率', tip: true, fmt: 'rate', width: 90 },
      { key: 'click_deal_rate', label: '点击-成交转化率(人数)', short: '点击成交率', tip: true, fmt: 'rate', width: 90 }
    ]
  }
]

const wechatConfigFields = [
  {
    name: '核心指标',
    type: 'core',
    fields: [
      { key: 'product_click_ucnt', label: '商品点击人数', short: '点击人数', fmt: 'bignum', width: 90, locked: true },
      { key: 'product_click_cnt', label: '商品点击次数', short: '点击次数', fmt: 'bignum', width: 90, locked: true },
      { key: 'click_add_to_cart_uv', label: '加购人数', short: '加购人数', fmt: 'num', width: 85 },
      { key: 'product_add_pay_converse_uv_ratio', label: '加购支付转化率', short: '加购转化率', fmt: 'rate', width: 90 },
      { key: 'product_click_pay_converse_uv_rate', label: '点击成交率', short: '点击成交率', fmt: 'rate', width: 90 }
    ]
  },
  {
    name: '交易指标',
    type: 'trade',
    fields: [
      { key: 'pay_amt', label: '下单金额', short: '下单金额', fmt: 'money', width: 100 },
      { key: 'pay_cnt', label: '下单订单数', short: '下单数', fmt: 'num', width: 80 },
      { key: 'pay_ucnt', label: '下单人数', short: '下单人数', fmt: 'num', width: 85 },
      { key: 'pay_jcnt', label: '下单件数', short: '下单件数', fmt: 'num', width: 85 },
      { key: 'income_amt', label: '成交金额', short: '成交金额', fmt: 'money', width: 100 },
      { key: 'net_income_amt', label: '成交金额（剔除退款）', short: '净成交额', fmt: 'money', width: 100 },
      { key: 'net_pay_cnt', label: '成交订单数', short: '成交订单', fmt: 'num', width: 85 },
      { key: 'net_pay_ucnt', label: '成交人数', short: '成交人数', fmt: 'num', width: 85 },
      { key: 'net_pay_pay_jcnt', label: '成交件数', short: '成交件数', fmt: 'num', width: 85 },
      { key: 'per_user_price', label: '客单价', short: '客单价', fmt: 'money', width: 80 },
      { key: 'product_add_pay_converse_uv_amt', label: '购物车成交金额', short: '购物车成交', fmt: 'money', width: 100 }
    ]
  },
  {
    name: '退款指标',
    type: 'refund',
    fields: [
      { key: 'pay_refund_success_amt', label: '成交退款金额', short: '成交退款', fmt: 'money', width: 95 },
      { key: 'pay_refund_success_ucnt', label: '成交退款人数', short: '退款人数', fmt: 'num', width: 85 },
      { key: 'pay_refund_success_ocnt', label: '成交退款订单数', short: '退款订单', fmt: 'num', width: 90 },
      { key: 'pay_refund_success_uv_rate', label: '成交退款率', short: '退款率', fmt: 'rate', width: 75 },
      { key: 'refund_amt', label: '退款金额', short: '退款金额', fmt: 'money', width: 95 },
      { key: 'refund_jcnt', label: '退款件数', short: '退款件数', fmt: 'num', width: 85 },
      { key: 'refund_cnt', label: '退款订单数', short: '退款订单', fmt: 'num', width: 90 },
      { key: 'refund_ucnt', label: '退款人数', short: '退款人数', fmt: 'num', width: 85 }
    ]
  },
  {
    name: '达人指标',
    type: 'talent',
    fields: [
      { key: 'talent_ucnt', label: '动销达人数', short: '达人数', fmt: 'num', width: 75 }
    ]
  }
]

const douyinDefaultFields = [
  'exposure', 'clicks', 'click_rate', 'add_cart', 'add_cart_rate',
  'real_orders', 'abnormal_orders', 'conversion_rate', 'return_rate',
  'pay_amount', 'order_count', 'buyer_count', 'avg_price',
  'refund_amount', 'refund_count',
  'exposure_uv', 'click_uv', 'exposure_click_rate', 'click_deal_rate',
  'stock'
]

const wechatDefaultFields = [
  'product_click_ucnt', 'product_click_cnt', 'click_add_to_cart_uv',
  'product_add_pay_converse_uv_ratio', 'product_click_pay_converse_uv_rate',
  'pay_amt', 'pay_cnt', 'pay_ucnt', 'income_amt', 'net_income_amt',
  'net_pay_cnt', 'net_pay_ucnt', 'per_user_price',
  'pay_refund_success_amt', 'pay_refund_success_uv_rate',
  'refund_amt', 'talent_ucnt'
]

const STORAGE_KEY_DOUYIN = 'product_board_field_config_douyin'
const STORAGE_KEY_WECHAT = 'product_board_field_config_wechat'

function createDefaultSearchData() {
  return {
    platform: 1,
    status:'',
    shop_id: '',
    product_id: '',
    product_name: '',
    group_id: '',
    sales_type: '全部',
    carrier_type: '全部',
    start_time: '',
    end_time: '',
    exposure_range: '',
    click_range: '',
    click_rate_range: '',
    cart_rate_range: '',
    cart_count_range: '',
    conversion_rate_range: '',
    real_order_range: '',
    abnormal_order_range: '',
    return_rate_range: '',
    wechat_click_cnt_range: '',
    wechat_click_ucnt_range: '',
    wechat_add_cart_uv_range: '',
    wechat_pay_cnt_range: '',
    wechat_net_pay_cnt_range: '',
    wechat_refund_cnt_range: '',
    wechat_click_pay_rate_range: '',
    wechat_refund_rate_range: ''
  };
}

function createDefaultRangeCustom() {
  return {
    exposure_min: '',
    exposure_max: '',
    click_min: '',
    click_max: '',
    click_rate_min: '',
    click_rate_max: '',
    cart_rate_min: '',
    cart_rate_max: '',
    cart_count_min: '',
    cart_count_max: '',
    conversion_rate_min: '',
    conversion_rate_max: '',
    real_order_min: '',
    real_order_max: '',
    abnormal_order_min: '',
    abnormal_order_max: '',
    return_rate_min: '',
    return_rate_max: '',
    wechat_click_cnt_min: '',
    wechat_click_cnt_max: '',
    wechat_click_ucnt_min: '',
    wechat_click_ucnt_max: '',
    wechat_add_cart_uv_min: '',
    wechat_add_cart_uv_max: '',
    wechat_pay_cnt_min: '',
    wechat_pay_cnt_max: '',
    wechat_net_pay_cnt_min: '',
    wechat_net_pay_cnt_max: '',
    wechat_refund_cnt_min: '',
    wechat_refund_cnt_max: '',
    wechat_click_pay_rate_min: '',
    wechat_click_pay_rate_max: '',
    wechat_refund_rate_min: '',
    wechat_refund_rate_max: '',
  };
}


export default {
  name: 'NewProductBoardPage',
  components:{Pagination},
  data() {
    return {
      searchData: createDefaultSearchData(),
      rangeCustom: createDefaultRangeCustom(),
      showRangeFilters:true,
      shopOptions: [],
      groupList: [],
      platformOptions: [
        { value: 1, label: '抖店' },
        { value: 7, label: '微店' }
      ],
      timeOptions: [
        { id: 1, name: '实时', day: 'realtime' },
        { id: 2, name: '近1天', day: '1' },
        { id: 3, name: '近7天', day: '7' },
        { id: 4, name: '近30天', day: '30' }
      ],
      salesTypeOptions: [
        { value: '全部', label: '全部' },
        { value: '自营', label: '自营' },
        { value: '合作', label: '合作' },
      ],
      carrierTypeOptions: [
        { value: '全部', label: '全部' },
        { value: '直播', label: '直播' },
        { value: '短视频', label: '短视频' },
        { value: '商品卡', label: '商品卡' },
        { value: '图文', label: '图文' },
      ],
      ddRangeFilter:[
        {label:'曝光区间',key:'exposure'},
        {label:'点击量区间',key:'click'},
        {label:'点击率区间',key:'click_rate'},
        {label:'加购率区间',key:'cart_rate'},
        {label:'加购量区间',key:'cart_count'},
        {label:'转化率区间',key:'conversion_rate'},
        {label:'真实订单区间',key:'real_order'},
        {label:'异常订单区间',key:'abnormal_order'},
        {label:'退货率区间',key:'return_rate'},
      ],
      wxRangeFilter:[
        {label:'点击次数区间',key:'wechat_click_cnt'},
        {label:'点击人数区间',key:'wechat_click_ucnt'},
        {label:'加购人数区间',key:'wechat_add_cart_uv'},
        {label:'下单订单数区间',key:'wechat_pay_cnt'},
        {label:'成交订单数区间',key:'wechat_net_pay_cnt'},
      ],
      datePickerOptions: {
        disabledDate(time) {
          // 禁用未来日期
          if (time.getTime() > Date.now()) {
            return true;
          }
          return false;
        },
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            // 选择了开始日期，限制结束日期在31天内
            const maxTime = minDate.getTime() + 31 * 24 * 60 * 60 * 1000;
            const minTime = minDate.getTime() - 31 * 24 * 60 * 60 * 1000;
            return {
              disabledDate(time) {
                const t = time.getTime();
                return t > maxTime || t < minTime || t > Date.now();
              }
            };
          }
        }
      },
      customDateRange: '',
      timeSelectId: 2,
      customStart: '',
      customEnd: '',
      tableData: [],
      selectedRows: [],
      pageData: { page: 1, limit: 20, total: 0 },
      douyinSelectedFields: [],
      wechatSelectedFields: [],
      tempSelectedFields: [],
      /* —— 指标配置 ——*/
      showFieldConfig: false,

      /* —— 分组管理 —— */
      groupMgmtVisible: false,
      groupFormVisible: false,
      groupForm: { id: null, name: '', sort: 0 },
      groupFormLoading: false,

      /* —— 批量设置分组 —— */
      batchGroupVisible:false,
      batchGroupLoading:false,
      batchGroupRows:0,
      batchGroupId:'',

      /* —— 发布任务 —— */
      publishVisible: false,
      publishMode: 'auto',
      publishStep: 1,
      publishFilter: { days: '7', sold: 'unsold', shopGroupId: '', productGroupId: '' },
      publishProducts: [],
      publishStart: 'now',
      publishDate: '',
      publishTaskTypes: [
        { key: 'comment', label: '评价任务', color: '#52c41a' },
        { key: 'sell', label: '动销任务', color: '#1677ff' },
        { key: 'output', label: '优产任务', color: '#fa8c16' }
      ],
      // 自定义发布
      customProductIds: '',
      customSubMode: 'template',
      customTemplateIdx: 0,
      customTemplates: [
        { name: '标准评价任务', type: 'comment', typeLabel: '评价任务', days: 7, daily: 5, total: 30, period: '09:00-21:00', steps: 4 },
        { name: '基础动销任务', type: 'sell', typeLabel: '动销任务', days: 7, daily: 10, total: 50, period: '09:00-21:00', steps: 3 },
        { name: '坑产提升任务', type: 'output', typeLabel: '坑产任务', days: 3, daily: 3, total: 10, period: '10:00-20:00', steps: 2 },
        { name: '测品推广任务', type: 'promote', typeLabel: '测品推广', days: 3, daily: 5, total: 20, period: '08:00-22:00', steps: 2 }
      ],
      customFullTaskOptions: [
        { key: 'comment', label: '评价任务', color: '#52c41a' },
        { key: 'sell', label: '动销任务', color: '#1677ff' },
        { key: 'output', label: '坑产任务', color: '#fa8c16' },
        { key: 'promote', label: '测品推广', color: '#a855f7' },
        { key: 'daily', label: '日常推广', color: '#c8443c' }
      ],
      customFullSelected: ['comment', 'sell', 'output'],
      customFullDays: 7,
      customFullDaily: 5,
      customFullTotal: 30,
      publishDayOptions: [
        { value: '1', label: '近1天' },
        { value: '3', label: '近3天' },
        { value: '7', label: '近7天' },
        { value: '14', label: '近14天' },
        { value: '30', label: '近30天' }
      ],
      publishSoldOptions: [
        { value: 'all', label: '全部' },
        { value: 'unsold', label: '未售过' },
        { value: 'done', label: '已做过' }
      ],
      shopGroupList: [],

      /* —— 数据洞察虚拟数据 —— */
      insightShow:true,
      insight: {
        riseList: [
          { product_id: 'P001', title: '字母短袖T恤男女夏季美式', delta: 16 },
          { product_id: 'P002', title: '满天星空图形短袖T恤男款', delta: 10 },
          { product_id: 'P003', title: '纯棉薄款垂感短袖休闲裤男', delta: 8 }
        ],
        refundList: [
          { product_id: 'P011', title: '满天星空图形短袖T恤男款', refund_rate: 11.11 },
          { product_id: 'P012', title: '字母短袖T恤男女夏季美式', refund_rate: 16.67 }
        ],
        lowConvList: [],
        group: {
          platformName: '抖店',
          total: 31,
          items: [
            { key: 'hot',    label: '爆款',     count:  3, delta:   3, pct:  10, color: '#C8443C' },
            { key: 'active', label: '动销款',   count:  8, delta:   8, pct:  26, color: '#1677FF' },
            { key: 'nodata', label: '无数据款', count:  6, delta:   6, pct:  19, color: '#B5BAC7' },
            { key: 'stuck',  label: '滞销款',   count: 14, delta: -14, pct:  45, color: '#FB923C' }
          ]
        }
      }
    }
  },
  computed: {
    configFields() {
      return this.searchData.platform === 7 ? wechatConfigFields : douyinConfigFields
    },
    selectedFields() {
      return this.searchData.platform === 7 ? this.wechatSelectedFields : this.douyinSelectedFields
    },
    activeFields() {
      const map = {}
      this.configFields.forEach((g) => g.fields.forEach((f) => { map[f.key] = f }))
      return this.selectedFields.map((k) => map[k]).filter((f) => !!f)
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.pageData.total / this.pageData.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.pageData.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    allChecked() {
      return this.tableData.length > 0 && this.selectedRows.length === this.tableData.length
    },
    pubCanSubmit() {
      if (this.publishMode === 'auto') return this.publishStep === 2
      // custom mode
      if (!this.customProductIds.trim()) return false
      if (this.customSubMode === 'custom' && this.customFullSelected.length === 0) return false
      return true
    },
    publishDaysText() {
      const hit = this.publishDayOptions.find((d) => d.value === this.publishFilter.days)
      return hit ? hit.label : ''
    },
    publishSoldText() {
      const hit = this.publishSoldOptions.find((s) => s.value === this.publishFilter.sold)
      return hit ? hit.label : ''
    },
    publishShopGroupText() {
      if (!this.publishFilter.shopGroupId) return '全部分组'
      const hit = this.shopGroupList.find((g) => g.id === this.publishFilter.shopGroupId)
      return hit ? hit.name : '全部分组'
    },
    publishProductGroupText() {
      if (!this.publishFilter.productGroupId) return '全部分组'
      const hit = this.groupList.find((g) => g.id === this.publishFilter.productGroupId)
      return hit ? hit.name : '全部分组'
    },
    statusOptions(){
      return  [
        { value: '', label: '全部',count:3 },
        { value: '1', label: '在售',color:'#52c41a',count:2 },
        { value: '2', label: '下架',color:'#999999',count:0 },
        { value: '3', label: '违规',color:'#c8443c',count:1 },
      ]
    },
  },
  created() {
    const storedDouyin = localStorage.getItem(STORAGE_KEY_DOUYIN)
    const storedWechat = localStorage.getItem(STORAGE_KEY_WECHAT)
    this.douyinSelectedFields = storedDouyin ? JSON.parse(storedDouyin) : [...douyinDefaultFields]
    this.wechatSelectedFields = storedWechat ? JSON.parse(storedWechat) : [...wechatDefaultFields]
    this.tempSelectedFields = [...this.selectedFields]
    this.loadShopList()
    this.loadGroupList()
    this.loadData(1)
  },
  methods: {
    ...mapActions({
      getProductBoardList: 'shop_board/getProductBoardList',
      getShopList: 'shop_board/getShopList',
      getProductBoardGroupList: 'shop_board/getProductBoardGroupList',
      getShopBoardGroupList: 'shop_board/getShopBoardGroupList',
      opProductBoardGroupCreate: 'shop_board/opProductBoardGroupCreate',
      opProductBoardGroupUpdate: 'shop_board/opProductBoardGroupUpdate',
      opProductBoardGroupDelete: 'shop_board/opProductBoardGroupDelete',
      opProductBoardBatchSetGroup: "shop_board/opProductBoardBatchSetGroup",
    }),
    loadShopList() {
      this.getShopList({
        data: { page_size: 100, page: 1, shop_type: this.searchData.platform },
        success: (res) => {
          if (res.code === 200 && res.data) {
            if (res.data.list && res.data.list.list) this.shopOptions = res.data.list.list
            else if (Array.isArray(res.data.list)) this.shopOptions = res.data.list
            else if (Array.isArray(res.data)) this.shopOptions = res.data
            else this.shopOptions = []
          }
        }
      })
    },
    loadGroupList() {
      this.getProductBoardGroupList({
        data: { with_count: 1 },
        success: (res) => {
          if (res.code === 200) this.groupList = res.data || []
        }
      })
    },
    switchPlatform(platform) {
      this.searchData.platform = platform
      this.searchData.shop_id = ''
      this.tempSelectedFields = [...this.selectedFields]
      this.loadShopList()
      this.loadData(1)
    },
    switchStatus(status) {
      this.searchData.status = status
      this.searchData.shop_id = ''
      this.tempSelectedFields = [...this.selectedFields]
      this.loadShopList()
      this.loadData(1)
    },
    selectTime(t) {
      this.timeSelectId = t.id
      this.customStart = ''
      this.customEnd = ''
      this.customDateRange=[]
    },
    resetSearch() {
      this.searchData = { platform: this.searchData.platform, shop_id: '', group_id: '' }
      this.timeSelectId = 2
      this.customStart = ''
      this.customEnd = ''
      this.loadData(1)
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    buildTimeParams() {
      const params = {}
      if (this.customStart && this.customEnd) {
        params.start_date = this.customStart
        params.end_date = this.customEnd
        return params
      }
      const today = this.formatDate(new Date())
      const t = this.timeOptions.find((x) => x.id === this.timeSelectId)
      if (t && t.day !== 'realtime') {
        const days = parseInt(t.day)
        const end = new Date()
        end.setDate(end.getDate() - 1)
        const start = new Date(end)
        start.setDate(start.getDate() - (days - 1))
        params.start_date = this.formatDate(start)
        params.end_date = this.formatDate(end)
      } else {
        params.start_date = today
        params.end_date = today
      }
      return params
    },

    // 区间筛选变化处理
    handleRangeChange(field) {
      const rangeValue = this.searchData[`${field}_range`];
      if (rangeValue !== 'custom') {
        // 清空自定义输入
        this.rangeCustom[`${field}_min`] = '';
        this.rangeCustom[`${field}_max`] = '';
      }
    },
    // 构建区间参数
    buildRangeParam(field, isPercentage = false) {
      let rangeValue = this.searchData[`${field}_range`]||'';
      const min = this.rangeCustom[`${field}_min`];
      const max = this.rangeCustom[`${field}_max`];
      // if (!min && !max) rangeValue = '';
      if (min && !max) rangeValue= isPercentage ? `${min}%+` : `${min}+`;
      if (min && max) rangeValue= isPercentage ? `${min}%-${max}%` : `${min}-${max}`;
      if (!min && max) rangeValue= isPercentage ? `0-${max}%` : `0-${max}`;
      this.$set(this.searchData, `${field}_range`, rangeValue||'')
    },
    customDateChange() {
      if (this.customDateRange && this.customDateRange.length === 2) {
        const start = new Date(this.customDateRange[0]);
        const end = new Date(this.customDateRange[1]);
        const diffDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
        if (diffDays > 31) {
          this.$message.warning('时间范围不能超过31天');
          this.customDateRange = '';
          return;
        }
        this.timeSelectId = '';
        this.searchData.start_time = this.customDateRange[0];
        this.searchData.end_time = this.customDateRange[1];
      } else {
        this.timeSelectId = 2;  // 清空时恢复为"近1天"
        this.searchData.start_time = '';
        this.searchData.end_time = '';
      }
      // this.loadData(1);
    },
    loadData(page) {
      this.pageData.page = page
      const params = {
        page: this.pageData.page,
        page_size: this.pageData.limit,
        // platform: this.searchData.platform
        ...this.searchData
      }
      Object.assign(params, this.buildTimeParams())
      Object.keys(this.searchData).forEach((key) => {
        if (this.searchData[key] === '') delete params[key]
      })
      this.getProductBoardList({
        data: params,
        success: (res) => {
          if (res.code === 200 && res.data) {
            if (Array.isArray(res.data)) {
              this.tableData = res.data
              this.pageData.total = res.data.length
            } else if (res.data.list) {
              this.tableData = res.data.list || []
              this.pageData.total = res.data.total || 0
            } else {
              this.tableData = []
              this.pageData.total = 0
            }
          } else {
            this.$message.error(res.msg || res.message || '获取数据失败')
            this.tableData = []
          }
        }
      })
    },
    platformName(platform) {
      if (platform === 1 || platform === '1') return '抖店'
      if (platform === 7 || platform === '7') return '微信小店'
      return platform
    },
    formatCell(col, val) {
      if (val === undefined || val === null || val === '') return '--'
      if (col.fmt === 'money') return Number(val).toFixed(2)
      if (col.fmt === 'rate') return val
      if (col.fmt === 'bignum') return Number(val).toLocaleString()
      return val
    },
    cellClass(col, val) {
      const n = parseFloat(val)
      if (isNaN(n) || n <= 0) return 'gx-pb__td-val--negative'
      if (col.fmt === 'money'&&n > 0) return 'gx-pb__td-val--positive'
      if ((col.key === 'order_count'||col.key === 'real_orders')&&n > 0) return 'gx-pb__td-val--green'
      return ''
    },
    toggleOne(id) {
      const idx = this.selectedRows.indexOf(id)
      if (idx > -1) this.selectedRows.splice(idx, 1)
      else this.selectedRows.push(id)
    },
    toggleAll() {
      if (this.allChecked) this.selectedRows = []
      else this.selectedRows = this.tableData.map((r) => r.product_id)
    },
    groupBar(type) {
      const map = { core: '#D4A946', trade: '#3FB6E0', refund: '#FB923C', traffic: '#4CAF7A', talent: '#8B5CF6' }
      return map[type] || '#D4A946'
    },
    groupCheckedCount(group) {
      return group.fields.filter((f) => this.tempSelectedFields.includes(f.key)).length
    },
    groupAllChecked(group) {
      return group.fields.filter((f) => !f.locked).every((f) => this.tempSelectedFields.includes(f.key))
    },
    toggleGroup(group) {
      if (this.groupAllChecked(group)) {
        this.tempSelectedFields = this.tempSelectedFields.filter((k) => !group.fields.some((f) => f.key === k && !f.locked))
      } else {
        group.fields.forEach((f) => {
          if (!f.locked && !this.tempSelectedFields.includes(f.key)) this.tempSelectedFields.push(f.key)
        })
      }
    },

    /**
     * —— 指标配置 ——*/
    openFieldConfig() {
      this.tempSelectedFields = [...this.selectedFields]
      this.showFieldConfig = true
    },
    closeFieldConfig() {
      this.showFieldConfig = false
    },
    confirmFieldConfig() {
      if (this.searchData.platform === 7) {
        this.wechatSelectedFields = [...this.tempSelectedFields]
        localStorage.setItem(STORAGE_KEY_WECHAT, JSON.stringify(this.wechatSelectedFields))
      } else {
        this.douyinSelectedFields = [...this.tempSelectedFields]
        localStorage.setItem(STORAGE_KEY_DOUYIN, JSON.stringify(this.douyinSelectedFields))
      }
      this.$message.success('指标配置已保存')
      this.showFieldConfig = false
    },

    /**
     * —— 发布任务 ——
     * */
    openPublishDialog() {
      this.publishVisible = true
      this.publishMode = 'auto'
      this.publishStep = 1
      this.publishProducts = []
      this.publishStart = 'now'
      this.publishDate = ''
      this.customProductIds = ''
      this.customSubMode = 'template'
      this.customTemplateIdx = 0
      this.customFullSelected = ['comment', 'sell', 'output']
      this.customFullDays = 7
      this.customFullDaily = 5
      this.customFullTotal = 30
      this.resetPublishFilter()
      if (!this.shopGroupList.length) this.loadShopGroupList()
    },
    loadShopGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) this.shopGroupList = res.data || []
        }
      })
    },
    closePublishDialog() {
      this.publishVisible = false
    },
    resetPublishFilter() {
      this.publishFilter = { days: '7', sold: 'unsold', shopGroupId: '', productGroupId: '' }
    },
    switchPublishMode(mode) {
      if (this.publishMode === mode) return
      this.publishMode = mode
      this.publishStep = 1
    },
    publishGoNext() {
      this.publishStep = 2
      this.matchPublishProducts()
    },
    matchPublishProducts() {
      const source = this.tableData.length
        ? this.tableData.slice(0, 3).map((r) => ({ product_id: r.product_id, title: r.title }))
        : [
            { product_id: '3820197411766716724', title: '满天星空图形短袖T恤男女夏季美式宽松休闲' },
            { product_id: 'WC023680001', title: '晴千花纯棉短袖连衣裙女夏季新款法式裙子' },
            { product_id: 'DP99283741', title: '晴格薄款垂感短袖休闲裤男夏季宽松' }
          ]
      this.publishProducts = source.map((item, idx) => {
        const type = this.publishTaskTypes[idx % this.publishTaskTypes.length]
        return {
          product_id: item.product_id,
          title: item.title,
          taskType: type.key,
          taskId: '',
          enter: 'scan',
          keywords: []
        }
      })
    },
    pubType(key) {
      let type =this.publishTaskTypes.find((t) => t.key === key) || this.publishTaskTypes[0]
      type.style={color:type.color,background:type.color+'18',border:`1px solid ${type.color+'55'}`}
      return type
    },
    addPublishKeyword(p) {
      p.keywords.push({ value: '' })
    },
    removePublishKeyword(p, i) {
      p.keywords.splice(i, 1)
    },
    toggleCustomFullTask(key) {
      const idx = this.customFullSelected.indexOf(key)
      if (idx > -1) this.customFullSelected.splice(idx, 1)
      else this.customFullSelected.push(key)
    },
    stepNum(val, delta) {
      const n = Number(val) || 0
      return Math.max(1, n + delta)
    },
    submitPublishTask() {
      if (this.publishStart === 'date' && !this.publishDate) {
        this.$message.warning('请选择开始日期')
        return
      }
      if (this.publishMode === 'custom' && !this.customProductIds.trim()) {
        this.$message.warning('请输入商品ID')
        return
      }
      if (this.publishMode === 'custom' && this.customSubMode === 'custom' && this.customFullSelected.length === 0) {
        this.$message.warning('请至少选择一个任务类型')
        return
      }
      this.$message.info('功能开发中，敬请期待')
    },

    /**
     * —— 分组管理 ——
     * */
    openGroupMgmt() {
      this.groupMgmtVisible = true
      this.loadGroupList()
    },
    openGroupForm(g) {
      if (g) this.groupForm = { id: g.id, name: g.name, sort: g.sort || 0 }
      else this.groupForm = { id: null, name: '', sort: 0 }
      this.groupFormVisible = true
    },
    submitGroupForm() {
      if (!this.groupForm.name) {
        this.$message.warning('请输入分组名称')
        return
      }
      if (this.groupFormLoading) return
      this.groupFormLoading = true
      const data = { name: this.groupForm.name.trim(), sort: this.groupForm.sort || 0 }
      const done = (res, msg) => {
        this.groupFormLoading = false
        if (res.code === 200) {
          this.$message.success(msg)
          this.groupFormVisible = false
          this.loadGroupList()
        } else {
          this.$message.error(res.message || res.msg || '保存失败')
        }
      }
      if (this.groupForm.id) {
        this.opProductBoardGroupUpdate({ id: this.groupForm.id, data, success: (res) => done(res, '修改成功') })
      } else {
        this.opProductBoardGroupCreate({ data, success: (res) => done(res, '新增成功') })
      }
    },
    delGroup(g) {
      this.$confirm(`确定要删除分组「${g.name}」吗？`, '提示', { type: 'warning' }).then(() => {
        this.opProductBoardGroupDelete({
          id: g.id,
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('删除成功')
              this.loadGroupList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }
        })
      }).catch(() => {})
    },
    moveProductGroup(row,index,type){
      if(index===0&&type==='asc') return
      if(index===this.groupList.length-1&&type==='desc') return
      let sort =0
      if(type==='asc') sort = this.groupList[index-1].sort-1
      if(type==='desc') sort = this.groupList[index+1].sort+1
      this.opProductBoardGroupUpdate({
        id: row.id,
        data:{ name: row.name.trim(), sort:sort<0?0:sort },
        success: (res) => {
          if(res.code===200){
            this.loadGroupList()
          }
        }
      })
    },

    /**
     * —— 批量设置分组 ——
     * */
    openBatchGroupDialog(rows) {
      const targetRows = Array.isArray(rows) && rows.length > 0 ? rows : this.selectedRows;
      if (!targetRows || targetRows.length === 0) {
        this.$message.warning('请先选择商品');
        return;
      }
      this.batchGroupRows = targetRows;
      this.batchGroupId = targetRows.length === 1 && targetRows[0].group_id ? targetRows[0].group_id : '';
      this.batchGroupVisible = true;
      this.loadGroupList({ withCount: false, force: this.groupList.length === 0 });
    },
    submitBatchSetGroup() {
      if (this.batchGroupId === '' || this.batchGroupId === null) {
        this.$message.warning('请选择分组');
        return;
      }
      if (this.selectedProductIds.length === 0) {
        this.$message.warning('未找到可设置的商品');
        return;
      }
      this.batchGroupLoading = true;
      const isRemoveGroup = this.batchGroupId === 0;
      this.opProductBoardBatchSetGroup({
        data: {
          product_ids: this.selectedProductIds,
          group_id: isRemoveGroup ? null : this.batchGroupId,
        },
        success: (res) => {
          this.batchGroupLoading = false;
          if (res.code === 200) {
            this.$message.success(isRemoveGroup ? '已移出分组' : '设置成功');
            this.batchGroupVisible = false;
            this.batchGroupRows = [];
            this.selectedRows = [];
            this.loadGroupList({ withCount: this.groupManageVisible, force: true });
            this.loadData();
          } else {
            this.$message.error(res.message || '设置失败');
          }
        }
      });
    },
  }
}
</script>

<style scoped>
.w50{
  width: 50px;
}
.gx-pb__head {
  display: flex;
  align-items: center;
  gap:8px;
  margin-bottom: 14px;
}

.gx-pb__btn {
  height: 32px;
  padding: 0 16px;
  box-sizing: border-box;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 13px;
  font-weight: 600;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  color: rgb(102, 102, 102);
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: none;
  transform: none;
}
.gx-pb__btn-sm{
  height: 26px;
  padding: 0px 10px;
  border-radius: 4px;
  font-size: 12px;
}
.gx-pb__btn--red{
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
  font-weight: 600;
  border: none;
  color: rgb(255, 255, 255);
  box-shadow: rgba(200, 68, 60, 0.3) 0px 2px 8px;
}
.gx-pb__btn--primary {
  background: linear-gradient(135deg, #D4A946, #E8B950);
  border: none;
  font-weight: 600;
  color: #F4F6F8;
}
.gx-pb__btn--primary:disabled{
  opacity: 0.5;
}
.gx-pb__btn--cancel{
  background: rgb(255, 255, 255);
  border: 1px solid rgba(212, 169, 70, 0.16);
  color: rgb(153, 153, 153);
}

/*平台tabs*/
.gx-pb__plat-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-pb__plat-tab {
  padding: 9px 24px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 14px;
  background: transparent;
  color: rgb(102, 102, 102);
  font-weight: 400;
}
.gx-pb__plat-tab--on {
  border-bottom:2px solid rgb(212, 169, 70);
  color: rgb(212, 169, 70);
  font-weight: 600;
}
/*状态筛选*/
.gx-pb__status-tabs {
  display: flex;
  background: rgb(255, 255, 255);
  border-radius: 0px 0px 8px 8px;
  border: 1px solid rgb(224, 224, 236);
  border-top: none;
  overflow-x: auto;
}
.gx-pb__status-tab{
  padding: 8px 18px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  font-weight: 400;
  background: transparent;
  color: rgb(102, 102, 102);
  white-space: nowrap;
  transition: 0.15s;
  display: flex;
  align-items: center;
  gap: 5px;
}
.gx-pb__status-tab-dot{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.gx-pb__status-tab--on{
  font-weight: 600;
  color: var(--gx-red);
  border-color:var(--gx-red) ;
}

.gx-pb__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  padding: 12px 14px;
  margin-top: 14px;
  margin-bottom: 12px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-wrap: wrap;
}
.gx-pb__filter  :deep(.el-input__inner){
  color: rgb(26,26,46);
}
.gx-pd__range{
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 10px;
  background: rgb(238, 241, 246);
  border-radius: 6px;
  border: 1px solid rgb(224, 224, 236);
}
.gx-pd__range-item{
  display: flex;
  align-items: center;
  gap: 3px;
}
.gx-pd__range-item-label{
   font-size: 11px;
   color: rgb(102, 102, 102);
   white-space: nowrap;
   flex-shrink: 0;
}
.gx-pd__range-item :deep(.el-input__inner){
  padding: 0 5px;
  height: 26px;
  line-height: 26px;
}
.gx-pd__btn-config{
  height: 28px;
  padding: 0px 12px;
  border-radius: 4px;
  cursor: pointer;
  background: rgba(212, 169, 70, 0.1);
  border: 1px solid rgba(212, 169, 70, 0.35);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(212, 169, 70);
  margin-left: auto;
}
.gx-pd__btn-config:hover{
  background: rgba(212, 169, 70, 0.25);
  color: rgb(232,185,80);
}
.gx-pb__time {
  display: flex;
  align-items: center;
  gap: 3px;
}
.gx-pb__time-btn {
  height: 26px;
  padding: 0 9px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 11px;
  background: #FFFFFF;
  border: 1px solid #E0E0EC;
  color: #666;
  transition: all .13s;
  white-space: nowrap;
}
.gx-pb__time-btn--on {
  background: #E1E5EE;
  border-color: rgba(212, 169, 70, .5);
  color: #D4A946;
}

.gx-pb__opts{
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.gx-pd__sel-tag{
  width: max-content;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 12px;
  border-radius: 4px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(200, 68, 60);
  font-weight: 500;
}
.gx-pd__sel-tag-dot{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
}

.table-page-wrapper{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 1px solid rgb(224, 224, 236);
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.gx-pb__page{
  padding: 10px 14px;
  border-top: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}
.gx-pb__table {
  background: #FFFFFF;
  border-radius: 8px 8px 0 0;
  overflow-x: auto;
}
.gx-pb__table::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.gx-pb__table::-webkit-scrollbar-thumb {
  background: rgba(212, 169, 70, .35);
  border-radius: 2px;
}
.gx-pb__table::-webkit-scrollbar-track {
  background: #F4F6F8;
}
.gx-pb__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-pb__table th {
  padding: 9px 12px;
  text-align: left;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgb(102, 102, 102);
  background: rgb(238, 241, 246);
  border-bottom: 1px solid rgb(224, 224, 236);
  cursor: default;
  user-select: none;
  white-space: nowrap;
}

.gx-pb__table td {
  padding: 10px 12px;
  font-family: "JetBrains Mono", monospace;
  font-size: 11px;
  color: rgb(26, 26, 46);
  border-bottom: 1px solid rgba(255,245,245);
}
.gx-pb__table tbody tr:hover td {
  background: rgba(245,245,245);
}

.gx-pb__check {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  border: 1.5px solid rgb(224, 224, 236);
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.gx-pb__check--on {
  background: rgb(200, 68, 60);
  border: 1.5px solid rgb(200, 68, 60);
}
.gx-pb__shop-cell {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 130px;
}
.gx-pb__shop-icon {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 10px;
  font-weight: 700;
  color: rgb(200, 68, 60);
  flex-shrink: 0;
}
.gx-pb__shop-name {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
  color: rgb(26, 26, 46);
}
.gx-pb__id {
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  color: rgb(153, 153, 153);
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gx-pb__td-title{
  max-width: 180px;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 12px;
  color: rgb(22, 119, 255);
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  text-decoration: none;
}
.gx-pb__td-val--positive {
  color:rgb(200, 68, 60);
}
.gx-pb__td-val--negative {
  color:rgb(153, 153, 153);
}
.gx-pb__td-val--green {
  color:rgb(82, 196, 26);
}

.gx-pb__plat-tag {
  padding: 1px 7px;
  border-radius: 4px;
  font-size: 10px;
}
.gx-pb__plat-tag--dy {
  background: rgba(251, 146, 60, .1);
  border: 1px solid rgba(251, 146, 60, .3);
  color: #FB923C;
}
.gx-pb__plat-tag--wx {
  background: rgba(74, 222, 128, .1);
  border: 1px solid rgba(74, 222, 128, .3);
  color: #22C55E;
}
.gx-pb__id-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
  min-width: 100px;
}

.gx-pb__group-tag {
  padding: 1px 7px;
  border-radius: 4px;
  background: rgba(139, 157, 195, .08);
  border: 1px solid rgba(139, 157, 195, .2);
  font-size: 10px;
  color: #4A4A6A;
}
.gx-pb__group-tag--empty {
  color: #999;
}

.gx-pb__empty {
  text-align: center!important;
  padding: 52px 0 !important;
  color: #999999 !important;
}

.gx-pb__modal {
  position: fixed;
  inset: 0;
  z-index: 700;
  background: rgba(0, 0, 0, .48);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.gx-pb__modal-box {
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .28);
  box-shadow: 0 20px 56px rgba(15, 23, 42, .14);
  overflow: hidden;
}
.gx-pb__modal-box--sm{
  max-width: 400px;
}
.gx-pb__modal-box--lg {
  max-width: 720px;
  max-height: 90vh;
  overflow-y: auto;
}
.gx-pb__modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #E1E5EE;
  position: sticky;
  top: 0;
  background: #FFFFFF;
}
.gx-pb__modal-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 15px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-pb__modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6A6A8A;
  font-size: 14px;
}
.gx-pb__modal-body {
  padding: 18px 20px;
}
.gx-pb__modal-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #E1E5EE;
  position: sticky;
  bottom: 0;
  background: #FFFFFF;
}
.gx-pb__modal-label {
  font-size: 11px;
  color: #6A6A8A;
  letter-spacing: .08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.gx-pb__modal-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(212, 169, 70, .22);
  font-size: 13px;
  color: #1A1A2E;
  outline: none;
  box-sizing: border-box;
}

.gx-pb__gm-sort-input {
  display: flex;
  align-items: center;
  border: 1px solid #E1E5EE;
  border-radius: 4px;
  overflow: hidden;
  width: 120px;
}
.gx-pb__gm-sort-input button {
  width: 32px;
  height: 32px;
  border: none;
  background: #eef1f6;
  cursor: pointer;
  font-size: 16px;
  color: #1A1A2E;
}
.gx-pb__gm-sort-input input {
  min-width: 0;
  flex: 1;
  height: 32px;
  border: none;
  outline: none;
  text-align: center;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  color: #1A1A2E;
}

.gx-pb__field-config-box {
  width: 100%;
  max-width: 520px;
  max-height: calc(100vh - 40px);
  border: none;
  border-radius: 10px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, .18);
}
.gx-pb__field-config-box .gx-modal-body {
  max-height: calc(100vh - 170px);
  overflow-y: auto;
  padding: 18px;
}
.gx-pb__field-config-box .gx-modal-foot--gray {
  padding: 14px 18px 16px;
  background: #EEF1F6;
}
.gx-pb__cfg-group {
  margin-bottom: 18px;
}
.gx-pb__cfg-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
  margin-bottom: 10px;
}
.gx-pb__cfg-bar {
  display: none;
}
.gx-pb__cfg-count {
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: #999999;
}
.gx-pb__cfg-checkall {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 11px;
  color: #999999;
  padding: 0;
  line-height: 18px;
}
.gx-pb__cfg-checkall:hover {
  color: #C8443C;
}
.gx-pb__cfg-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
}
.gx-pb__cfg-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 28px;
  padding: 4px 11px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  background: #F5F5F5;
  cursor: pointer;
  font-size: 12px;
  line-height: 18px;
  color: #666666;
  user-select: none;
  transition: border-color .15s, background-color .15s, color .15s;
}
.gx-pb__cfg-item input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}
.gx-pb__cfg-item:hover {
  border-color: rgba(200, 68, 60, .65);
}
.gx-pb__cfg-item--on {
  background: #FFF5F5;
  border-color: #C8443C;
  color: #C8443C;
}
.gx-pb__cfg-item--on::before {
  content: '\2713';
  margin-right: 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
}
.gx-pb__field-config-modal {
  padding: 20px;
  background: rgba(26, 26, 46, .44);
  backdrop-filter: blur(4px);
}


.gx-pb__cfg-item--locked {
  opacity: .6;
  cursor: not-allowed;
}
.gx-pb__cfg-locked {
  margin-left: auto;
  font-size: 10px;
  color: #999;
}

.gx-pb__gm-toolbar {
  margin-bottom: 12px;
}
.gx-pb__gm-table {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgb(224, 224, 236);
}
.gx-pb__gm-table table {
  width: 100%;
  border-collapse: collapse;
}
.gx-pb__gm-table th {
  padding: 8px 12px;
  text-align: left;
  background: rgb(238, 241, 246);
  font-size: 11px;
  font-weight: 500;
  color:#666;
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-pb__gm-table td {
  padding: 8px 12px;
  font-size: 13px;
  color: #1A1A2E;
  border-top: 1px solid rgb(245, 245, 245);
}

.gx-pb__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-pb__red {
  color: rgb(200,68,60);
  font-weight: 600;
}
.gx-pb__gm-sort {
  display: flex;
  gap: 3px;
}
.gx-pb__gm-sort button {
  width: 22px;
  height: 22px;
  border-radius: 3px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
  transition: all .16s;
}
.gx-pb__gm-sort button:hover {
  border-color: #C8443C;
  color: #C8443C;
}

.gx-pb__gm-name {
  font-weight: 500;
}
.gx-pb__gm-count {
  font-family: 'JetBrains Mono', monospace;
  color: #C8443C;
  font-weight: 600;
}
.gx-pb__gm-ops {
  display: flex;
  gap: 6px;
}
.gx-pb__gm-op {
  height: 24px;
  padding: 0px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-family: "Noto Sans SC", sans-serif;
  font-size: 11px;
}
.gx-pb__gm-op--edit {
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: rgb(22, 119, 255);
}
.gx-pb__gm-op--edit:hover {
  background:rgb(22, 119, 255);
  color: #FFFFFF;
}
.gx-pb__gm-op--del {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  color: rgb(200, 68, 60);
}
.gx-pb__gm-op--del:hover {
  background: rgb(200, 68, 60);
  color: #FFFFFF;
}
</style>
<style scoped>
.w140{
  width: 140px;
}
.w180{
  width: 180px;
}
.select-custom-option{
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.select-custom-option :deep(.el-input){
  width: 85px;
}

/* ===== 数据洞察 ===== */
.gx-pb__insight {
  margin-bottom: 12px;
}
.gx-pb__insight-head {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  margin-bottom: 10px;
  padding: 7px 12px;
  border-radius: 8px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(224, 224, 236);
  user-select: none;
}
.gx-pb__insight-bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: #D4A946;
}

.gx-pb__insight-title {
  font-family: "Noto Serif SC", serif;
  font-size: 12px;
  font-weight: 700;
  color: rgb(26, 26, 46);
  position: relative;
  padding-left: 10px;
}
.gx-pb__insight-title::before{
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 3px;
  height: 13px;
  border-radius: 2px;
  background: rgb(200, 68, 60);
}
.gx-pb__insight-dec {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  flex: 1 1 0%;
}
.gx-pb__insight-tabs {
  margin-left: 14px;
  display: flex;
  gap: 4px;
  overflow-x: auto;
}
.gx-pb__insight-tabs::-webkit-scrollbar { height: 0; }
.gx-pb__insight-tab {
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  border: 1px solid #E0E0EC;
  background: #FFFFFF;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
}
.gx-pb__insight-tab--on {
  border-color: rgba(212, 169, 70, .5);
  background: rgba(212, 169, 70, .12);
  color: #D4A946;
}

.gx-pb__insight-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.gx-pb__insight-card {
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  font-family: "Noto Sans SC", sans-serif;
}
.gx-pb__insight-card--rise  { background: rgb(255, 245, 245);border: 1px solid rgb(255, 204, 199); }
.gx-pb__insight-card--refund{ background: rgb(255, 248, 230);border: 1px solid rgb(255, 213, 145); }
.gx-pb__insight-card--conv  { background: rgb(249, 240, 255);border: 1px solid rgb(211, 173, 247); }
.gx-pb__insight-card--group { background: #FFFFFF;border: 1px solid rgb(224, 224, 236); }

.gx-pb__insight-card-head {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 9px;
}
.gx-pb__insight-icon {
  font-size: 14px;
  line-height: 1;
}
.gx-pb__insight-card-title {
  font-size: 11px;
  font-weight: 700;
  flex: 1;
}

.gx-pb__insight-badge {
  font-family: "JetBrains Mono", monospace;
  font-size: 9px;
}

.gx-pb__insight-tag {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 10px;
  flex-shrink: 0;
}
.gx-pb__insight-tag--group { background: #E1E5EE; color: #4A4A6A; }

.gx-pb__insight-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.gx-pb__insight-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
}
.gx-pb__insight-card--rise .gx-pb__insight-row{ border-bottom: 1px solid rgba(200, 68, 60, 0.12);}
.gx-pb__insight-card--refund .gx-pb__insight-row{ border-bottom: 1px solid rgba(250, 140, 22, 0.15);}
.gx-pb__insight-card--conv .gx-pb__insight-row{ border-bottom: 1px solid rgba(211, 173, 247,0.15);}
.gx-pb__insight-list .gx-pb__insight-row:last-child{
  border-bottom: none;
}

.gx-pb__insight-rank {
  font-family: "JetBrains Mono", monospace;
  font-size: 9px;
  color: rgb(153, 153, 153);
  width: 14px;
  text-align: center;
}

.gx-pb__insight-name {
  flex: 1;
  min-width: 0;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-pb__insight-val {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
}
.gx-pb__insight-val--up   { color: #C8443C; }
.gx-pb__insight-val--down { color: #16A34A; }
.gx-pb__insight-val--warn { color: #E8831A; }

.gx-pb__insight-empty {
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 10px;
  color: rgb(153, 153, 153);
  text-align: center;
  padding: 8px 0;
}

/* 分组分布 */
.gx-pb__insight-bars {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.gx-pb__insight-bar-row { }
.gx-pb__insight-bar-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3px;
}
.gx-pb__insight-bar-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.gx-pb__insight-bar-label {
  font-family: "Noto Sans SC", sans-serif;
  font-size: 10px;
  font-weight: 600;
}
.gx-pb__insight-bar-count {
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  color: rgb(102, 102, 102);
}
.gx-pb__insight-bar-delta {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  min-width: 32px;
  text-align: right;
}
.gx-pb__insight-bar-track {
  height: 6px;
  border-radius: 3px;
  background: rgba(0, 0, 0, .06);
  overflow: hidden;
}
.gx-pb__insight-bar-fill {
  display: block;
  height: 100%;
  border-radius: 3px;
  transition: width .4s ease;
}

.gx-pb__insight-foot {
  margin-top: 8px;
  font-family: "JetBrains Mono", monospace;
  font-size: 9px;
  color: rgb(153, 153, 153);
  text-align: right;
}
.gx-pb__insight-total {
  font-family: 'JetBrains Mono', monospace;
  font-weight: 600;
  color: #1A1A2E;
  margin: 0 2px;
}

@media (max-width: 1100px) {
  .gx-pb__insight-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 640px) {
  .gx-pb__insight-grid { grid-template-columns: 1fr; }
}

/* ===== 发布任务弹窗 ===== */
.gx-pb__pub-box {
  max-width:660px;
}
.gx-pb__pub-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(135deg, rgb(200, 68, 60), rgb(224, 88, 88));
}
.gx-pb__pub-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #FFFFFF;
}
.gx-pb__pub-head-ops {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-pb__pub-reset {
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, .7);
  background: transparent;
  color: #FFFFFF;
  font-size: 11px;
  cursor: pointer;
}
.gx-pb__pub-reset:hover {
  background: rgba(255, 255, 255, .15);
}
.gx-pb__pub-close {
  width: 26px;
  height: 26px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 11px;
}
.gx-pb__pub-tabs {
  display: flex;
  border-bottom: 1px solid rgb(224, 224, 236);
}
.gx-pb__pub-tab {
  flex: 1;
  padding: 12px 16px 10px;
  cursor: pointer;
  background: #FFFFFF;
  border-bottom: 2px solid transparent;
}
.gx-pb__pub-tab + .gx-pb__pub-tab {
  border-left: 1px solid rgb(224, 224, 236);
}
.gx-pb__pub-tab--on {
  background: #FDF2F1;
  border-color: var(--gx-red);
}
.gx-pb__pub-tab-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-pb__pub-tab--on .gx-pb__pub-tab-title {
  color: rgb(200, 68, 60);
}
.gx-pb__pub-tab-sub {
  margin-top: 4px;
  font-size: 11px;
  color: rgb(153, 153, 153);
}
.gx-pb__pub-steps {
  display: flex;
  align-items: center;
  padding: 16px 16px 4px;
}
.gx-pb__pub-step {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
}
.gx-pb__pub-step-no {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border: 1px solid rgb(216, 220, 227);
  color: rgb(153, 153, 153);
  background: #FFFFFF;
}
.gx-pb__pub-step--on .gx-pb__pub-step-no {
  background: rgb(200, 68, 60);
  border-color: rgb(200, 68, 60);
  color: #FFFFFF;
}
.gx-pb__pub-step-label {
  font-size: 13px;
  font-weight: 600;
  color: rgb(153, 153, 153);
}
.gx-pb__pub-step--on .gx-pb__pub-step-label {
  color: #1A1A2E;
}
.gx-pb__pub-step-line {
  flex: 1;
  height: 1px;
  margin: 0 12px;
  background: rgb(229, 224, 220);
}
.gx-pb__pub-step-line--on {
  background: rgb(200, 68, 60);
}
.gx-pb__pub-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 20px;
}
.gx-pb__pub-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 12px 0 8px;
  font-size: 12px;
  font-weight: 500;
  color: rgb(74, 74, 106);
}
.gx-pb__pub-label-no {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid rgb(201, 205, 216);
  color: rgb(102, 102, 102);
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-pb__pub-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.gx-pb__pub-pill {
  height: 26px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgb(227, 230, 236);
  background: #FFFFFF;
  color: rgb(74, 74, 106);
  font-size: 12px;
  cursor: pointer;
}
.gx-pb__pub-pill--red {
  background: rgb(200, 68, 60);
  border-color: rgb(200, 68, 60);
  color: #FFFFFF;
}
.gx-pb__pub-pill--yellow {
  background: #D4A946;
  border-color: #D4A946;
  color: #FFFFFF;
}
.gx-pb__pub-groups {
  display: flex;
  gap: 14px;
}
.gx-pb__pub-group-label {
  margin-bottom: 6px;
  font-size: 11px;
  color: rgb(153, 153, 153);
}
.gx-pb__pub-next-wrap {
  display: flex;
  justify-content: flex-end;
  padding: 18px 0 8px;
}
.gx-pb__pub-next {
  height: 30px;
  padding: 0 16px;
  border: none;
  border-radius: 6px;
  background: rgb(200, 68, 60);
  color: #FFFFFF;
  font-size: 13px;
  cursor: pointer;
}
.gx-pb__pub-next:hover {
  background: rgb(180, 58, 52);
}
.gx-pb__pub-cond {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 4px;
}
.gx-pb__pub-cond-label {
  font-size: 12px;
  color: rgb(74, 74, 106);
}
.gx-pb__pub-cond-pill {
  height: 20px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 204, 199);
  font-size: 11px;
  color: var(--gx-red);
  display: inline-flex;
  align-items: center;
}
.gx-pb__pub-cond-edit {
  height: 20px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid rgb(227, 230, 236);
  background: #FFFFFF;
  font-size: 11px;
  color: rgb(102, 102, 102);
  cursor: pointer;
}
.gx-pb__pub-cond-edit:hover {
  color: rgb(200, 68, 60);
  border-color: rgba(200, 68, 60, .4);
}
.gx-pb__pub-match-tip {
  margin: 10px 0 8px;
  font-size: 12px;
  color: rgb(51, 51, 74);
}
.gx-pb__pub-match-tip b {
  color: rgb(200, 68, 60);
}
.gx-pb__pub-banner {
  padding: 8px 10px;
  border-radius: 6px;
  background: rgb(230, 244, 255);
  border: 1px solid rgb(145, 202, 255);
  color: var(--gx-cyan);
  font-size: 12px;
  margin-bottom: 12px;
}
.gx-pb__pub-cards {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-pb__pub-card {
  background: rgb(250, 250, 250);
  border: 1px solid rgb(238, 230, 230);
  border-radius: 10px;
  padding: 10px 12px;
}
.gx-pb__pub-card-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.gx-pb__pub-card-ico {
  font-size: 16px;
  line-height: 1.4;
}
.gx-pb__pub-card-info {
  flex: 1;
  min-width: 0;
}
.gx-pb__pub-card-title {
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-pb__pub-card-id {
  margin-top: 2px;
  font-size: 10px;
  color: rgb(153, 153, 153);
  font-family: 'JetBrains Mono', monospace;
}
.gx-pb__pub-tasktag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.gx-pb__pub-card-box {
  margin-top: 8px;
  border: 1px solid rgb(238, 230, 230);
  border-radius: 8px;
  padding: 8px 10px;
}
.gx-pb__pub-card-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gx-pb__pub-row-space {
  flex: 1;
}
.gx-pb__pub-taskpill {
  padding: 2px 8px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.gx-pb__pub-taskid {
  font-size: 11px;
  color: rgb(153, 153, 153);
  font-family: 'JetBrains Mono', monospace;
}
.gx-pb__pub-scan,
.gx-pb__pub-search {
  height: 24px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px solid rgb(227, 230, 236);
  background: #FFFFFF;
  color: rgb(153, 153, 153);
  font-size: 11px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.gx-pb__pub-scan--on,
.gx-pb__pub-search--on {
  background: rgb(22, 119, 255);
  border-color: rgb(22, 119, 255);
  color: #FFFFFF;
}
.gx-pb__pub-kw-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
.gx-pb__pub-kw-del {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid rgb(227, 230, 236);
  background: #FFFFFF;
  color: rgb(153, 153, 153);
  font-size: 10px;
  cursor: pointer;
}
.gx-pb__pub-kw-del:hover {
  color: rgb(200, 68, 60);
  border-color: rgba(200, 68, 60, .4);
}
.gx-pb__pub-kw-add {
  margin-top: 8px;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  border: 1px dashed rgb(22, 119, 255);
  background: #FFFFFF;
  color: rgb(22, 119, 255);
  font-size: 11px;
  cursor: pointer;
}
.gx-pb__pub-kw-add:hover {
  background: rgba(22, 119, 255, .06);
}
.gx-pb__pub-submit:disabled {
  background: rgb(216, 220, 227);
  border: none;
  color: #FFFFFF;
  opacity: 1;
}
.gx-pb__pub-submit:not(:disabled) {
  background: rgb(200, 68, 60);
  border: none;
  color: #FFFFFF;
  font-weight: 600;
}

/* ===== 自定义发布 ===== */
.gx-pb__pub-cust{
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.gx-pb__pub-cust-step {
  padding: 12px 14px;
  border-radius: 8px;
  background: rgb(255, 248, 230);
  border: 1px solid rgba(212, 169, 70, 0.4);
}
.gx-pb__pub-cust-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #666666;
  margin-bottom: 8px;
}
.gx-pb__pub-cust-step-no {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #D4A946;
  color: #FFFFFF;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gx-pb__pub-cust-hint {
  margin-bottom: 6px;
  font-size: 11px;
  color: #666666;
}
.gx-pb__pub-cust-warn {
  margin-top: 6px;
  font-size: 11px;
  color: rgb(250, 140, 22);
}
.gx-pb__pub-sub-tabs {
  display: flex;
  border: 1px solid rgb(227, 230, 236);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
}
.gx-pb__pub-sub-tab {
  flex: 1;
  height: 30px;
  border: none;
  background: #FFFFFF;
  color: rgb(102, 102, 102);
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.gx-pb__pub-sub-tab + .gx-pb__pub-sub-tab {
  border-left: 1px solid rgb(227, 230, 236);
}
.gx-pb__pub-sub-tab--on {
  background: rgb(200, 68, 60);
  color: #FFFFFF;
  font-weight: 600;
}
.gx-pb__pub-sub-tab-ico {
  font-size: 13px;
}
.gx-pb__pub-tpl-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gx-pb__pub-tpl-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgb(227, 230, 236);
  border-radius: 8px;
  background: #FFFFFF;
  cursor: pointer;
}
.gx-pb__pub-tpl-item--on {
  border-color: rgb(200, 68, 60);
  background: #FDF2F1;
}
.gx-pb__pub-tpl-radio {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid rgb(216, 220, 227);
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gx-pb__pub-tpl-item--on .gx-pb__pub-tpl-radio {
  border-color: rgb(200, 68, 60);
}
.gx-pb__pub-tpl-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
}
.gx-pb__pub-tpl-main {
  flex: 1;
  min-width: 0;
}
.gx-pb__pub-tpl-name {
  font-size: 13px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-pb__pub-tpl-detail {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: rgb(102, 102, 102);
}
.gx-pb__pub-tpl-detail span {
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(200, 68, 60, .08);
  color: rgb(150, 55, 50);
}
.gx-pb__pub-tpl-tag {
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.gx-pb__pub-tpl-days {
  font-size: 11px;
  color: rgb(153, 153, 153);
  font-family: 'JetBrains Mono', monospace;
}
.gx-pb__pub-cust-label {
  font-size: 11px;
  color: #666666;
  margin-bottom: 8px;
}
.gx-pb__pub-sub-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
.gx-pb__pub-sub-pill {
  height: 30px;
  padding: 0 13px;
  border-radius: 15px;
  color: rgb(102, 102, 102);
  background: rgb(245, 245, 245);
  border: 1px solid rgb(224, 224, 236);
  font-size: 12px;
  cursor: pointer;
}
.gx-pb__pub-cust-nums {
  display: flex;
  gap: 20px;
}
.gx-pb__pub-cust-num {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.gx-pb__pub-cust-num label {
  font-size: 10px;
  color: #999999;
  white-space: nowrap;
}
.gx-pb__pub-num-wrap {
  display: flex;
  align-items: center;
  border: 1px solid rgb(227, 230, 236);
  border-radius: 4px;
  overflow: hidden;
  height: 26px;
}
.gx-pb__pub-num-btn {
  width: 26px;
  height: 26px;
  border: none;
  background: #F4F6F8;
  color: #1A1A2E;
  font-size: 14px;
  cursor: pointer;
}
.gx-pb__pub-num-btn:hover {
  background: #E6E9EF;
}
.gx-pb__pub-num-input {
  width: 48px;
  height: 26px;
  border: none;
  border-left: 1px solid rgb(227, 230, 236);
  border-right: 1px solid rgb(227, 230, 236);
  text-align: center;
  font-size: 12px;
  font-family: 'JetBrains Mono', monospace;
  outline: none;
  -moz-appearance: textfield;
}
.gx-pb__pub-num-input::-webkit-inner-spin-button,
.gx-pb__pub-num-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
